import { scope } from "@gr-exports/async/debug";
import { toggle } from "@gr-exports/async/toggle";
const grScope = scope("gr");
const deprScope = grScope.scope("deprecated");
const TOGGLE_PREFIX = "gr_legacy_";
const getToggleName = (type, moduleId) => `${TOGGLE_PREFIX}${type}_${moduleId.replace(/-/g, "_")}`;
const processInvocation = (log, moduleId, funcId, message, enableToggle, reportToggle) => {
  const id = `gr/${moduleId}/${funcId}`;
  const dataObject = new Error(`${id}: ${message}`);
  const caller = `${dataObject.stack}`.split("\n").filter((f) => f.includes(" at "))[2]?.trim() ?? `unknown script`;
  log.warn(
    id,
    "is deprecated but called from",
    caller,
    "\nReporting controlled by toggle",
    reportToggle,
    "\nAvailability controlled by toggle",
    enableToggle
  );
  return [dataObject, caller];
};
function deprecated(handler, ...meta) {
  const log = deprScope.scope(`${meta[0]}.${meta[1]}`);
  const toggles = [getToggleName("enable", meta[0]), getToggleName("report", meta[0])];
  if (!toggle.get(toggles[0], true))
    return (() => {
      const [error, caller] = processInvocation(log, ...meta, ...toggles);
      if (toggle.get(toggles[1], false))
        otto.apm.sendCustomError(`assets-legacy`, error, { caller });
      throw error;
    });
  return ((...args) => {
    const [dataObject, caller] = processInvocation(log, ...meta, ...toggles);
    if (toggle.get(toggles[1], false))
      otto.apm.sendCustomError(`assets-legacy`, dataObject, { caller });
    return handler(...args);
  });
}
export {
  deprecated,
  grScope
};
